import { render, staticRenderFns } from "./JoinButton.vue?vue&type=template&id=419b637a&scoped=true&"
import script from "./JoinButton.vue?vue&type=script&lang=js&"
export * from "./JoinButton.vue?vue&type=script&lang=js&"
import style0 from "./JoinButton.vue?vue&type=style&index=0&id=419b637a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419b637a",
  null
  
)

export default component.exports